import { render, staticRenderFns } from "./CenterFrame.vue?vue&type=template&id=002d4a2e&"
import script from "./CenterFrame.vue?vue&type=script&lang=js&"
export * from "./CenterFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports